export function Card({ children, className = "", ...props }) {
  return <div className={`bg-[#FBF9F4] border border-[#E3DCCB] rounded-xl shadow-[0_6px_24px_rgba(23,42,58,0.04)] ${className}`} {...props}>{children}</div>;
}

export function Eyebrow({ children }) {
  return <div className="eyebrow text-[#8C7444]">{children}</div>;
}

const STATE_TONE = {
  "Ready": "ok", "Delivered": "ok", "Completed": "ok", "Active": "ok", "Viewed": "ok", "Scheduled": "ok", "Eligible": "ok",
  "Awaiting Operator Review": "warn", "Under Review": "warn", "In Preparation": "warn", "Awaiting Operator": "warn",
  "Clarification Requested": "warn", "Awaiting Customer": "warn", "Adjustment Needed": "warn", "Scheduling": "warn",
  "In Progress": "info", "Onboarding": "info", "Purchased": "info", "Submitted": "info", "Preparation": "info",
};

const STATE_LABEL = {
  "Awaiting Operator Review": "Awaiting Consultant Review",
  "Awaiting Operator": "Awaiting Consultant",
};

export function StatusPill({ state }) {
  const tone = STATE_TONE[state] || "muted";
  const cls = {
    ok: "bg-[#667A66]/12 text-[#4d6b4d]", warn: "bg-[#C49A5A]/15 text-[#8a6a2e]",
    info: "bg-[#9F634E]/12 text-[#9F634E]", muted: "bg-[#E5E1D8] text-[#6B665E]",
  }[tone];
  return <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full ${cls}`}>{STATE_LABEL[state] || state}</span>;
}

export function PageTitle({ eyebrow, title, sub }) {
  return (
    <div className="mb-8">
      {eyebrow && <div className="eyebrow text-[#8C7444] mb-2">{eyebrow}</div>}
      <h1 className="font-academic font-semibold text-4xl sm:text-5xl text-[#172A3A] tracking-tight">{title}</h1>
      <div className="h-px w-24 bg-[#BDA677] mt-4" />
      {sub && <p className="text-[#4F5B67] mt-4 text-[15px] max-w-2xl leading-relaxed">{sub}</p>}
    </div>
  );
}

export const btnPrimary = "bg-[#172A3A] hover:bg-[#22394D] text-[#F5F2E9] rounded-full px-5 py-2.5 text-sm transition-colors disabled:opacity-60";
export const btnGhost = "border border-[#E3DCCB] hover:border-[#BDA677] text-[#172A3A] rounded-full px-5 py-2.5 text-sm transition-colors";
export const fieldCls = "w-full bg-[#FBF9F4] border border-[#E3DCCB] rounded-lg px-4 py-2.5 text-[#172A3A] text-[15px] focus:outline-none focus:border-[#BDA677] focus:ring-1 focus:ring-[#BDA677]/40 transition-colors";
